import { proactive } from 'services';

const postSendAlert = () => {
  return proactive.post('/');
};

export { postSendAlert };
